import Text from 'components/corporatiu/Text';
import Enllac from 'components/corporatiu/Enllac';
import Imatge from 'components/corporatiu/Imatge';
import styles from './imatgeTextBoto.module.scss';
import __isEmpty from 'lodash/isEmpty';

const ImatgeTextBoto = (props) => {
    const { img, alt, text, entradeta, telefon, botoText, url, estil, etiqueta } = props;

    return (
        <aside className={`${styles.aside} ${estil ? styles[estil] : ''}`}>
            {etiqueta && (
                <div className={styles.etiqueta}>
                    <div className={styles.titol}>{etiqueta}</div>
                </div>
            )}
            {img && url && (
                <Enllac href={url}>
                    <div className={styles.imatgeWrapper}>
                        <Imatge src={img} alt={alt} className={styles.imatge} layout='fill' objectFit='cover' />
                    </div>
                </Enllac>
            )}
            <div className={styles.content}>
                {!__isEmpty(text) && <Text tag='div' className={styles.text} text={text} />}
                {!__isEmpty(entradeta) && <Text tag='div' className={styles.entradeta} text={entradeta} />}
                {telefon && (
                    <div className={styles.phoneWrapper}>
                        <Enllac href={`tel:${telefon}`} className={styles.phone}>
                            {telefon}
                        </Enllac>
                    </div>
                )}
                {botoText && url && (
                    <Enllac href={url} className={styles.boto}>
                        {botoText}
                    </Enllac>
                )}
            </div>
        </aside>
    );
};

export default ImatgeTextBoto;
